import PropTypes from 'prop-types'

const skuShape = PropTypes.shape({
  variations: PropTypes.array,
  measurementUnit: PropTypes.string,
  productId: PropTypes.string,
  name: PropTypes.string,
  refId: PropTypes.string,
  ean: PropTypes.string,
  selectedSlaObj: PropTypes.object,
  sellers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      default: PropTypes.bool,
      commertialOffer: PropTypes.shape({
        availableQuantity: PropTypes.number,
        listPrice: PropTypes.number,
        price: PropTypes.number,
      }),
    })
  ),
  images: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.string,
})

const productShape = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  brand: PropTypes.string,
  description: PropTypes.string,
  specifications: PropTypes.array,
  skus: PropTypes.arrayOf(skuShape),
  variations: PropTypes.array,
  skuChosen: skuShape,
})

const customerShape = PropTypes.shape({
  documentType: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  document: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  email: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  homePhone: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  addressType: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  country: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  state: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  city: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  postalCode: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  neighborhood: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  street: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  number: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  complement: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  lastCart: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.shape({
          sku: PropTypes.string,
          qty: PropTypes.string,
          seller: PropTypes.string,
          sc: PropTypes.string,
        })
      ),
      PropTypes.string,
    ]),
    products: PropTypes.arrayOf(productShape),
  }),
  lastCartAmount: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.number,
  }),
  lastSessionDate: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  brandPurchasedTag: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  categoryPurchasedTag: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  productPurchasedTag: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  checkouttag: PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.string,
  }),
  fullName: PropTypes.shape({
    data: PropTypes.string,
  }),
  extraData: PropTypes.object,
})

export default customerShape
